import * as React from 'react';
import {Props as LayoutProps} from "./HomePageLayout";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export type Props = {
	Layout: any
};

export const schema = {
	featureSection: {
		foregroundImage: "https://s3.ca-central-1.amazonaws.com/images.faizhirani.com/mariamrazi.com/Mariam_Razi_web2.png",
	},
	blurbSection: {
		title: "About Mariam Razi",
		paras: [
			"I am a skilled policy innovator, political strategist, and government relations expert with over a decade of experience crafting policy and leading advocacy campaigns across Canada, the U.S., and international jurisdictions.",
			"As a former executive and trained civil servant, I’ve led regional and national advocacy initiatives for public, private, and nonprofit organizations—helping them advance their policy agendas, secure public funding, and build lasting government and community partnerships.",
			"I specialize in public policy design, integrated public affairs strategy, and coalition-building, with a strong track record at the intersection of politics, business, and grassroots mobilization.",
			'My work spans healthcare, economic development, technology and innovation, and social impact—but what unites it all is a deep belief in the power of clear policy and strong relationships to move meaningful change. I’ve lobbied across federal and provincial governments, advised on cross-border issues, and helped organizations of all sizes craft persuasive narratives to support their mission and amplify their impact.',
			"Before launching Razi Strategies, my independent public affairs practice, I served in the Government of Ontario and worked as a fundraiser and policy strategist for both the Federal and Ontario Liberal parties in Canada. This frontline experience provided me with the tactical insights and political judgment I apply to every engagement, whether in the public eye or behind closed doors."
		],
	},
	valuePropsSection: {
		title: "How I Work",
		subtitle: "I bring a collaborative, values-driven approach rooted in:",
		valueProps: [
			{
				title: "Strategic Clarity",
				content: "Aligning advocacy with organizational goals and political realities",
				icon: [
					'fal',
					'chess-queen-piece'
				] // Represents precision/targeting
			},
			{
				title: "Coalition-Building",
				content: "Bridging interests across sectors, regions, and political lines",
				icon: [
					'fal',
					'circle-nodes'
				] // Represents networks/bridging
			},
			{
				title: "Storytelling",
				content: "Crafting messages that are authentic, credible, and designed to move decision-makers",
				icon: [
					'fal',
					'typewriter'
				] // Represents communication/narrative
			},
			{
				title: "Storytelling",
				content: "Crafting narratives that resonate with policymakers, not just stakeholders",
				icon: [
					'fal',
					'comment-dots'
				] // Represents communication/narrative
			},
			{
				title: "Global Fluency",
				content: "Working across borders and cultural contexts, including North America, Europe, and the Middle East",
				icon: [
					'fal',
					'earth-americas'
				] // Represents international/global scope
			},
			{
				title: "Policy Foresight",
				content: "Anticipating political and regulatory shifts to position organizations for long-term success",
				icon: [
					'fal',
					'crystal-ball'
				] // Represents international/global scope
			},
		]
	},
	educationSection: {
		title: "Education & Background",
		items: [
			{
				school: "University of Toronto",
				degree: "BA (Hons)",
				speciality: "Political Science, European History, and Middle Eastern Studies"
			},
			{
				school: "University of Waterloo",
				degree: "Master of Public Service (MPS)",
				speciality: ""
			},
			{
				school: "Seneca Polytechnic",
				degree: "Postgraduate Certificate",
				speciality: "Government Relations Management"
			}
		]
	},
	bulletSection: {
		image: "https://s3.ca-central-1.amazonaws.com/images.faizhirani.com/mariamrazi.com/Mariam_Razi_web2.png",
		title: "A good policy strategist should never be one-dimensional",
		bullets: [
			{
				icon: <FontAwesomeIcon icon={['fal', 'check']} />,
				title: 'Mentoring',
				text: 'I have mentored many emerging women leaders',
			},
			{
				icon: <FontAwesomeIcon icon={['fal', 'check']} />,
				title: 'Geopolitics and International Affairs',
				text: 'I always keep a close eye',
			},
			{
				icon: <FontAwesomeIcon icon={['fal', 'check']} />,
				title: 'Travel',
				text: "I've explored X countries and am eager to explore more",
			},
			{
				icon: <FontAwesomeIcon icon={['fal', 'check']} />,
				title: 'Fitness',
				text: 'Something about fitness.',
			},
			{
				icon: <FontAwesomeIcon icon={['fal', 'check']} />,
				title: 'Fashion',
				text: 'Something about fashion',
			},
		],
	},
	genericSections: [
		// {
		// 	title: "Beyond the Brief",
		// 	content: "Outside of work, I enjoy public speaking, mentoring emerging women leaders, and keeping a close eye on geopolitics and international affairs. I also make time for travel, fitness, and the occasional deep dive into fashion and culinary experimentation—because a good policy strategist should never be one-dimensional.",
		// },
		// {
		// 	title: "Beyond the Brief",
		// 	content: "Outside of work, I mentor emerging women leaders, keep a close eye on geopolitics and international affairs, and make time for travel and creative exploration — because a good strategist should never be one-dimensional.",
		// },
		{
			title: "Let's Work Together",
			content: "If you're navigating policy reform, launching an advocacy campaign, or expanding into a new market, I bring the insight, creativity, and discipline to help you succeed—across sectors, across borders, and with impact that lasts.",
		},
		{
			title: "Let's Work Together",
			content: "If you’re navigating policy reform, launching an advocacy campaign, or expanding into a new market, I bring the strategy, clarity, and discipline to help you succeed — across sectors, across borders, and with impact that lasts.",
		}
	]
};


export const HomePageContainer = (props: Props) =>
{
	const render = () =>
	{
		const Layout = props.Layout;
		const outgoingProps: LayoutProps = {
			schema
		};
		const returnValue = <Layout {...outgoingProps} />;
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};
